module.exports = __webpack_public_path__ + "media/images/app/homepage/couture/cartier-878076c4cc7ce0090f8019337027948a.webp";